import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { forgotPassword } from "../../actions/user";
import email from '../../public/images/email.png';
import logo from '../../public/images/logo.png';

const ForgotPassword = (props) => {
    const history = useHistory();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: ""
    });

    //onchange input field
    const handleChange = (e) => {
        const { value, name } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrorMessages({ ...errorMessages, [name]: "" });
    }

    //validation form on email  
    const validateForm = () => {
        let errors = {};
        let formIsValid = true;

        if (!formData.email) {
            formIsValid = false;
            errors = { ...errors, email: "Please enter your email." };
        }
        else if (typeof formData.email !== "undefined") {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(formData.email.trim())) {
                formIsValid = false;
                errors = { ...errors, email: "Please enter valid email." };
            }
        }

        setErrorMessages(errors);
        return formIsValid;
    }

    //form submit on forgot password 
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.email) {
            toast.error("Please enter email address");
            return;
        }
        else if (formData.email && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(formData.email)) {
            toast.error("Please enter valid email address");
            return;
        }

        if (validateForm()) {
            setLoading(true);
            
            let params = {
                type: "email",
                email: formData.email.trim()
            }

            localStorage.setItem("email", formData.email.trim());
            
            props.forgotPassword(params, res => {
                setLoading(false);
                if (res.status) {
                    toast.success(res.message);
                    history.push('/verify-otp');
                }
                else {
                    toast.error(res.message);
                }
            },
                err => {
                    setLoading(false);
                    toast.error(err.message);
                }
            )
        }

    };

    useEffect(() => {
        document.title = "forgot-password";
    }, []);

    return (
        <>
            {/* <!-- Start Main --> */}
            <section className="adminLogin">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 p-0">
                            <div className="loginContent pt-5 ps-3">
                                <div onClick={() => { history.push('/login') }} className="logo">
                                    <img className="img-responsive" src={logo} />
                                </div>
                                <div className="loginForm mt-5">
                                    <form onSubmit={(e) => { handleSubmit(e) }} className="loginHorizontalForm_">
                                        <h3 className="mb-2">Forgot Password</h3>
                                        <p className="mb-5">Enter the below details for forgot password:</p>
                                        <div className="groupInputs_ mb-4">
                                            <label className="loginIcon">
                                                <img src={email} />
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="email"
                                                placeholder='Email'
                                                value={formData.email}
                                                onChange={(e) => { handleChange(e) }}
                                            />
                                        </div>
                                        <button className="btnTheme" disabled={loading} type="submit">
                                            {loading && (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            &nbsp;&nbsp;
                                            <span>Continue</span>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 p-0">
                            <div className="loginImage">
                                <p className="innerContent">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it
                                    look like readable English.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- End Main --> */}
        </>
    )

}

const mapStateToProps = state => ({
    auth: state.auth
});

const mapDispatchToProps = dispatch => ({
    forgotPassword: bindActionCreators(forgotPassword, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);